<template>
  <div id='trackTable' class='h100vh-100'>
    <MonitTableMenu @methodEnum='methodEnum'></MonitTableMenu>
    <MonitTable ref="monitTable"></MonitTable>
  </div>
</template>
<script>
import MonitTableMenu from './MonitTableMenu';
import MonitTable from './MonitTable';

export default {
  name: 'MonitTaskList',
  components: {
    MonitTableMenu,
    MonitTable
  },
  data() {
    return {};
  },
  methods: {
    methodEnum(opcode) {
      this.$refs.monitTable.queryConditions.status = opcode.value;
      this.$refs.monitTable.getTrackListData();
    }
  }
};
</script>